import { createFileRoute } from '@tanstack/react-router';
import { UpdatePasswordPage } from '../components/pages/SettingsPage/UpdatePasswordPage';

export const Route = createFileRoute('/account/settings_/password')({
  component: UpdatePasswordPage,
});
